import React, { Fragment } from "react";
import { jsx, css } from "@emotion/react";
import colors from "../../../../styles/colors";

const styles = {
  container: css`
    height: 40px;
    position: relative;
    margin-bottom: 8px;
    text-align: center;
  `,
  title: css`
    box-sizing: border-box;
    color: ${colors.generalColors.darkGray};
    display: block;
    line-height: 40px;
    border-bottom: 1px solid ${colors.generalColors.lightGray};
    margin: 0 12px;
    overflow: hidden;
    padding: 0 32px;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
    /* z-index: 1; */
  `,
  close: css`
    color: ${colors.generalColors.darkGray};
    padding: 10px 12px 10px 8px;
    position: absolute;
    top: 0;
    right: 0;
    /* z-index: 2; */
    cursor: pointer;
    &::before {
      content: "\\2715";
    }
  `,
};

const PopoverHeader = (props) => {
  return (
    <div css={styles.container}>
      <span css={styles.title}>{props.title}</span>
      <span css={styles.close} onClick={props.onClose}></span>
    </div>
  );
};

export default PopoverHeader;
